import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import '@styles/main.less';

import UsersList from './Users';
import CreateUser from './CreateUser';
import ViewUser from './ViewUser';
import EditUser from './EditUser';

function UsersPage(props) {
  const {
    match: { url }
  } = props;

  return (
    <Switch>
      <Route exact path={`${url}/`} component={UsersList} />
      <Route exact path={`${url}/create`} component={CreateUser} />
      <Route path={`${url}/:id/edit`} component={EditUser} />
      <Route path={`${url}/:id`} component={ViewUser} />
    </Switch>
  );
}

UsersPage.propTypes = {
  match: PropTypes.object
};

export default UsersPage;
